import events from 'events.js';
import ko from 'knockout';

import analytics from 'analytics.js';
import NameSearchManager from 'professional/referrals.js';

import 'ko/bindings/stop_binding.js';

window._trackedInteraction = false;

function handleInteraction(evt) {
    window.evt = evt;
    if (!window._trackedInteraction) {
        const integrationUsageId =
            document.body.dataset.integrationUsageId || '';
        analytics.track('referralsInteraction', {
            'x_coords': evt.x,
            'y_coords': evt.y,
            'interaction_element': `${evt.target.localName}.${evt.target.className}`,
            'integration_usage_id': integrationUsageId,
            'interaction_type': evt.type,
            redesign: false,
            url: location.href,
        });
        window._trackedInteraction = true;
    }
}

events.ready().then(async function () {
    const integrationUsageId = document.body.dataset.integrationUsageId || '';
    analytics.track('referralsIndex', {
        redesign: false,
        url: location.href,
        'integration_usage_id': integrationUsageId,
    });
    window.addEventListener('mousedown', handleInteraction);
    window.addEventListener('keydown', handleInteraction);
    const items = document.querySelectorAll('a[data-toggle="tab"]');
    for (const item of items) {
        events.listen(item, 'tabShown', function () {
            if (window.localStorage) {
                localStorage.lastTab = item.getAttribute('href');
            }
            const elem = document.querySelector(item.getAttribute('href'));
            const input = elem.querySelector('input[type="text"]');
            if (input) {
                input.focus();
            }
        });
    }
    if (window.localStorage && localStorage.lastTab) {
        const t = document.querySelector(`a[href="${localStorage.lastTab}"]`);
        events.trigger(t, 'click');
    }

    const showProFilter = document.body.dataset.showProFilter;
    const manager = new NameSearchManager();
    await manager.loadSpecialties({showProFilter});
    ko.applyBindings(manager, document.getElementById('profile'));
});
